import { useMemo } from 'react';

import { DayOfWeek, WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { DAYS_OF_WEEK } from '../../../form/fields/AllDaysPreferencesField/AllDaysPreferencesField.constants';
import { TIMES_OF_DAY } from '../../../form/fields/DayPreferenceField/DayPreferenceField.constants';

import { PatientAvailabilities } from './PatientAvailabilityPreferenceCell.types';

export const MAX_DISPLAYABLE_DAYS_COUNT = 2;

export const usePatientAvailabilities = (
   patientAvailability: WaitlistEntry['patientAvailability']
): PatientAvailabilities => {
   const patientAvailabilities = Object.entries(patientAvailability)
      .map(([dayOfWeek, timesOfDay]) => ({
         dayOfWeek: dayOfWeek as DayOfWeek,
         timesOfDay: timesOfDay.sort((timeA, timeB) => TIMES_OF_DAY.indexOf(timeA) - TIMES_OF_DAY.indexOf(timeB)),
      }))
      .sort(
         (availabilityA, availabilityB) =>
            DAYS_OF_WEEK.indexOf(availabilityA.dayOfWeek) - DAYS_OF_WEEK.indexOf(availabilityB.dayOfWeek)
      );
   return useMemo(
      () => ({
         displayableAvailabilities: patientAvailabilities.slice(0, MAX_DISPLAYABLE_DAYS_COUNT),
         allAvailabilities: patientAvailabilities,
      }),
      [patientAvailabilities]
   );
};
